const OfferStatusEnum = Object.freeze({
	FINISHED: 4,
	PROSPECTS: 6,
	PILOT_FISHING: 7,
	ROADSHOW: 8,
	RASCUNHO_ROADSHOW: 9,
	RASCUNHO_PILOT_FISHING: 10,
});

export default OfferStatusEnum;
